const MULTIPART = { 'Content-Type': 'multipart/form-data' };

export default function WaitlistApi({ makeRequest, buildRequest }) {
	function createWaitlist(payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Waitlist', payload))
		);
	}

	function updateWaitlist(waitlistId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.put(`/api/Waitlist/${waitlistId}`, payload))
		);
	}

	function getWaitlist(waitlistId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Waitlist/${waitlistId}`))
		);
	}

	function getActiveWaitlists() {
		return buildRequest().then((req) =>
			makeRequest(req.get('/api/Waitlist/active'))
		);
	}

	function getWaitlistPrefill(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Waitlist/prefill/${enquiryId}`))
		);
	}

	function getWaitlistSummaryByCentre(centreId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Waitlist/summary/centre/${centreId}`))
		);
	}

	function getWaitlistSummaryByEnquiry(enquiryId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Waitlist/summary/enquiry/${enquiryId}`))
		);
	}

	function closeWaitlist(waitlistId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Waitlist/${waitlistId}/close`, payload))
		);
	}

	function createWaitlistInvitation(waitlistId, contactIds) {
		return buildRequest().then((req) =>
			makeRequest(req.post('/api/Waitlist/invitation', { waitlistId, contactIds }))
		);
	}

	function uploadWaitlistFile(waitlistId, file, onUploadProgress) {
		const form = new FormData();
		form.append('file', file, file.name);
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Waitlist/${waitlistId}/files`, form, { headers: MULTIPART, onUploadProgress }))
		);
	}

	function initWaitlistUpload(waitlistId, payload) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Waitlist/${waitlistId}/files/init`, payload))
		);
	}

	function uploadWaitlistBlock(waitlistId, uploadId, index, chunk) {
		const form = new FormData();
		form.append('chunk', chunk);
		return buildRequest().then((req) =>
			makeRequest(req.put(
				`/api/Waitlist/${waitlistId}/files/${uploadId}/block/${index}`,
				form,
				{ headers: MULTIPART, timeout: 120000, suppressErrorToast: true },
			))
		);
	}

	function commitWaitlistUpload(waitlistId, uploadId, blockIndexes) {
		return buildRequest().then((req) =>
			makeRequest(req.post(`/api/Waitlist/${waitlistId}/files/${uploadId}/commit`, { blockIndexes }))
		);
	}

	function getWaitlistFileContent(waitlistId, waitlistFileId) {
		return buildRequest().then((req) =>
			makeRequest(req.get(`/api/Waitlist/${waitlistId}/files/${waitlistFileId}`, { responseType: 'blob' }))
		);
	}

	function deleteWaitlistFile(waitlistId, waitlistFileId) {
		return buildRequest().then((req) =>
			makeRequest(req.delete(`/api/Waitlist/${waitlistId}/files/${waitlistFileId}`))
		);
	}

	return {
		createWaitlist,
		updateWaitlist,
		getWaitlist,
		getActiveWaitlists,
		getWaitlistPrefill,
		getWaitlistSummaryByCentre,
		getWaitlistSummaryByEnquiry,
		closeWaitlist,
		createWaitlistInvitation,
		uploadWaitlistFile,
		initWaitlistUpload,
		uploadWaitlistBlock,
		commitWaitlistUpload,
		getWaitlistFileContent,
		deleteWaitlistFile,
	};
}
